/**
 * Wrapper class for Abide. Add custom validation functions to forms.
 * @author Michel Heitbrink
 */
import $ from 'jquery';
import { Abide } from 'foundation-sites';

class Validator {

    constructor(options) {

        this.options = {
            formSelector: 'form[data-form-validate]',
            classes: {
                error: 'c-form__error',
                isValid: 'is-valid',
                isInvalid: 'is-invalid'
            },
            customValidators: {
                password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\#])[A-Za-z\d@$!%*?&\#]{8,}$/
            }
        };

        this.options = Object.assign(this.options, options);
    }

    init() {
        document.querySelectorAll(this.options.formSelector).forEach( (form) => {
            this.create(form, this.options);
        });
    }

    create( form, options ) {

        options = Object.assign(this.options, options);

        /**
         * Add custom validators to Abide
         */
        if ( options.customValidators && Object.keys(options.customValidators).length > 0 ) {

            Object.keys(this.options.customValidators).forEach( (key) => {
                if ( typeof options.customValidators[key] == "function" ) {
                    Abide.defaults.validators[key] = options.customValidators[key];
                }
                else {
                    Abide.defaults.patterns[key] = options.customValidators[key];
                }
            });
        }

        /**
         * Add foundation Abide to the form
         */
        const abide = new Abide($(form), {
            //inputErrorClass: '',
            //labelErrorClass: '',
            formErrorSelector: ( options.classes && options.classes.error ) ? options.classes.error : '',
            validateOnBlur: true
        });

        $(form).data('abideClass', abide);

        /**
         * Add event listeners
         */
        $(form).on('invalid.zf.abide', (event, $elem) => {
            if ( $elem ) {
                $elem.parent().removeClass(options.classes.isValid);
                $elem.parent().addClass(options.classes.isInvalid);
            }
        });

        $(form).on('valid.zf.abide', (event, $elem) => {
            if ( $elem ) {
                $elem.parent().removeClass(options.classes.isInvalid);
                $elem.parent().addClass(options.classes.isValid);
            }
        });

        $(form).on('formreset.zf.abide', (event, $elem) => {
            $(form).find('.' + options.classes.isInvalid).removeClass(options.classes.isInvalid);
        });

        /**
         * Prevent default submit and trigger event post.
         */
        $(form).on("formvalid.zf.abide", (event, $elem) => {
            const ev = document.createEvent('Event');
    		ev.initEvent('valid', true, false);

            form.dispatchEvent(ev);
        });

        $(form).on("forminvalid.zf.abide", (event, $elem) => {
            const ev = document.createEvent('Event');
    		ev.initEvent('valid', true, false);

            form.dispatchEvent(ev);
        });

        $(form).on('submit', function(e) { e.preventDefault() });

    }
}

export default Validator;


/*
---
name: Validator
category: JavaScript
subcategory: Helpers
---

Examples
======
A wrapper to add foundation's abide to your form. add the property `data-form-validate` to your form element and trigger Setup.init when the page is ready with loading.
The validator is added by default to your project. To disable the validator simple add the option `assign.validator = false` to  Setup.init.

##### Options:
- **formSelector** (String) - The selector the determine which form has the abide functionality.
- **classes** (Object) - Parameters will be posted as formdata or querystring based on request method
    - **error** - (String) - Class added to the error message container. By default `.c-form__error`
    - **isValid** - (String) - The class will be added to a invalid input's container. By default `.is-valid`
    - **isInvalid** - (String) - The class will be added to a valid input's container. By default `.is-invalid`
- **customValidators** (Object) - Object with custom validators. By default the validator password is added.

```js
Setup.init();

const form = document.querySelector('#example-form');

if ( form ) {

    form.addEventListener('valid', (event) => {

        event.preventDefault();

        const rqst = new ServerRequest();

        rqst.submit('#example-form', 'method').then( (response) => {
            console.log(response);
        });
    });

    form.addEventListener('invalid', (event) => {
        console.error('invalid form');
    });
}

```
*/
